import React from 'react';

const Actions = (props) => {
  return (
  	<React.Fragment>
	  	<div className="container section editor-actions for-admin">	  	
		  	<button className="btn btn--action" onClick={() => props.onDebug()}>Отладка</button>
		  	<button className="btn btn--primary" onClick={() => props.onSave()}>Сохранить</button>
		  	<button className="btn btn--outline" onClick={() => props.onCancel()}>Отменить</button>
	  	</div>
  	</React.Fragment>
  );
};

export default Actions;
